import { EntityCategoryValue } from './entity-category-value.model';


export class EntityCategory {
  id: number;
  active: boolean;
  created: string;
  updated: string;
  name?: string;
  protectedCategory: boolean;
  shortName: string;
  categoryValues?: Array<EntityCategoryValue>;
  newCategoryValue?: Array<object>;
  instanceValues?: Array<object>;
  color: string;
  activeFilter?: boolean;

  constructor (cat: any = {}) {
    this.id = cat.id || null;
    this.active = cat.active || null;
    this.created = cat.created || null;
    this.updated = cat.updated || null;
    this.name = cat.name || null;
    this.protectedCategory = cat.protectedCategory || false;
    this.categoryValues = cat.categoryValues || null;
    this.newCategoryValue = cat.newCategoryValue || [];
    this.instanceValues = cat.instanceValues || [];
    this.color = cat.color || '';
    this.activeFilter = cat.activeFilter || false;
  }
}
